import React, { useContext } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import AnalyteSelectorButton from '../../../elem/chart/AnalyteSelectorButton'
import ResetDropDownButton from '../../../elem/chart/ResetDropDownButton'
import CollapseButton from '../../../elem/list/CollapseButton'
import ExpandButton from '../../../elem/list/ExpandButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'

export default () => {
    const {
        displayAnalyteWindowDropdown,
        toggleAnalyteWindowDropdown,
        analyteList,
        setCollapsed,
        isCollapsed,
        resetExpanded,
        toggleResetExpanded,
    } = useContext(DataContext)

    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Aggregate Analyte Chart</div>
            <div className="panelButtons">
                <ResetDropDownButton
                    resetExpanded={resetExpanded}
                    toggleResetExpanded={toggleResetExpanded}
                />
                {analyteList && analyteList.length ? (
                    <AnalyteSelectorButton
                        displayAnalyteWindowDropdown={
                            displayAnalyteWindowDropdown
                        }
                        toggleAnalyteWindowDropdown={
                            toggleAnalyteWindowDropdown
                        }
                    />
                ) : null}
                <div className="panelHeaderIconWrapper">
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`analyte-aggregate`}
                            isCollapsed={isCollapsed}
                            setIsCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={`analyte-aggregate`}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}
